import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import { FormsQuestionModelTypes, IFormsQuestionModelState, IFormsResponseValidation } from './types'

const FormsQuestionModel: IQuestionModelConstructor<FormsQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<FormsQuestionModelTypes, IFormsQuestionModelState>({
    questionType: QuestionType.FORMS,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IFormsQuestionModelState) {
  // const naAnswerIndex = questionSchema.answers.findIndex(answer => answer.na)
  // const naAnswerChecked = naAnswerIndex > 0 && response[naAnswerIndex].valid
  //
  // if (naAnswerChecked) {
  //   return [{ id: response[naAnswerIndex].id }]
  // }
  //
  // return response
  //   .filter((_answer, index) => index != naAnswerIndex)
  //   .map(answer => {
  //     const submitAnswerResponse: ArrayElementType<FormsSubmitResponse> = { id: answer.id, valid: answer.valid }
  //     if (answer.comment) {
  //       submitAnswerResponse.c = answer.comment
  //     }
  //     return submitAnswerResponse
  //   })
  return response.data
}

function initState(state: IFormsQuestionModelState): IFormsQuestionModelState {
  state.response = {
    data: state.questionSchema.answers.map(answer => {
      return {
        id: answer.id,
        c: answer.optional ? '' : answer.mask,
        valid: !answer.mask_ast?.error && answer.optional
      }
    }),
    valid: false
  }
  return state
}

function validateResponse({ response }: IFormsQuestionModelState): IFormsResponseValidation {
  // const naAnswerIndex = questionSchema.answers.findIndex(answer => answer.na)
  // const naAnswerChecked = naAnswerIndex > 0 && response[naAnswerIndex].valid
  // if (naAnswerChecked) return { valid: true }

  return {
    valid: response.valid
  }
}

export default FormsQuestionModel
